import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, markPrivacyAccepted, isPrivacyAccepted, Options} from "../utils/decorators";

@Options({
    template: false,
    ui: {
        acceptContainer:   "[data-js-ui=accept-container]",
        acceptButton:      "[data-js-ui=accept-button]",
    }
})
export default class PrivacyAcceptView extends Marionette.View<Backbone.Model>{

    onRender(){

        let pluginHeader = $('.plugin-fe .plugin-header');
        let hasEditBar = pluginHeader.length > 0 ? true : false;
        let offsetHeight = 0;

        let body = $('body');
        body.addClass('privacy-hide');
        let footerLinks = <HTMLElement>document.querySelector('[data-js-ui=tertiary-footer]');

        if (hasEditBar) offsetHeight = pluginHeader.height();

        if (isPrivacyAccepted()){
            this.ui.acceptContainer.show();
            body.addClass('privacy-display');
            body.removeClass('privacy-hide');

            if (footerLinks) {
                footerLinks.classList.add('has-footer-message');
            }
        }
    }
    @on("click @ui.acceptButton")
    onAcceptButtonClick(e) {
        let body = $('body');

        markPrivacyAccepted();

        let footerLinks = <HTMLElement>document.querySelector('[data-js-ui=tertiary-footer]');
        if (footerLinks) {
            footerLinks.classList.remove('has-footer-message');
        }

        this.ui.acceptContainer.hide();
        body.removeClass('privacy-display');
        body.addClass('privacy-hide');
    }
}



// WEBPACK FOOTER //
// ./@modules/views/privacy-accept-view.ts